<form
  [formGroup]="displayModeForm"
  class="d-flex align-items-center justify-content-center"
>
  <div class="btn-group btn-group-toggle">
    @if (showSizes) {
    <label
      class="btn btn-sm btn-delivery-mode btn-light"
      [class.btn-delivery-mode-active]="
        (displayByMode === DisplayByMode.Size ||
          displayByMode === DisplayByMode.AdvancedSize ||
          !showPrepacks) &&
        showSizes
      "
      data-e2e="c-strip-sizes-button"
    >
      <input
        type="radio"
        [value]="DisplayByMode.Size"
        formControlName="displayMode"
      />
      {{ displaySizeModeLabel }}
    </label>
    } @if (showPrepacks) {
    <label
      class="btn btn-sm btn-delivery-mode btn-light"
      [class.btn-delivery-mode-active]="
        (displayByMode === DisplayByMode.Prepack ||
          displayByMode === DisplayByMode.AdvancedPrepack ||
          !showSizes) &&
        showPrepacks
      "
      data-e2e="c-strip-pre-pack-button"
    >
      <input
        type="radio"
        [value]="DisplayByMode.Prepack"
        formControlName="displayMode"
      />
      {{ displayPrepackModeLabel }}
    </label>
    }
  </div>
</form>
